// Configuración de entornos
const environments = {
  development: {
    API_URL: 'https://localhost:50403/api',
    NAME: 'Desarrollo',
    DEBUG: true,
    TIMEOUT: 30000
  },
  test: {
    API_URL: 'https://localhost:50403/api',
    NAME: 'Pruebas',
    DEBUG: true,
    TIMEOUT: 30000
  },
  production: {
    API_URL: 'https://api.mafy.mx/api',
    NAME: 'Producción',
    DEBUG: false,
    TIMEOUT: 15000
  }
};

// Obtener configuración actual basada en variables de entorno
const getCurrentEnvironment = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT || 'development';
  return {
    ...environments[envName],
    NAME: envName,
    API_URL: process.env.REACT_APP_API_URL || environments[envName].API_URL
  };
};

export const config = getCurrentEnvironment();

export default config;